import { render, staticRenderFns } from "./RegisterCertificate.vue?vue&type=template&id=5fd4a17c&scoped=true&"
import script from "./RegisterCertificate.vue?vue&type=script&lang=js&"
export * from "./RegisterCertificate.vue?vue&type=script&lang=js&"
import style0 from "./RegisterCertificate.vue?vue&type=style&index=0&id=5fd4a17c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd4a17c",
  null
  
)

export default component.exports